import CircularLoader from 'components/molecules/CircularLoader/CircularLoader';
import { useTraitsLazyQuery } from 'generated/graphql';
import { FC, useEffect, useState } from 'react';
import TraitsHeader from './TraitsHeader/TraitsHeader';
import TraitsList from './TraitsList/TraitsList';

const Traits: FC = () => {
  const [isArchivedVisible, setIsArchivedVisible] = useState(false);

  const [traitsQuery, traitsQueryResponse] = useTraitsLazyQuery();

  useEffect(() => {
    traitsQuery({
      variables: {
        isArchived: isArchivedVisible ? undefined : false,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isArchivedVisible]);

  if (traitsQueryResponse.loading) {
    return <CircularLoader />;
  }

  if (traitsQueryResponse.data) {
    const traits = traitsQueryResponse.data.Traits;
    return (
      <div>
        <TraitsHeader
          isArchivedVisible={isArchivedVisible}
          setIsArchivedVisible={setIsArchivedVisible}
        />
        <TraitsList traits={traits || []} />
      </div>
    );
  }

  return null;
};

export default Traits;
